import { i18n } from '../internationalization';
import { getBundleKeyForLanguage, getLoadPromiseForLanguage, loadTranslationsForLanguage } from '../load-translations';

/**
 * Ensures the given language's translation bundle is loaded.
 * Throws the load promise (for React Suspense) until the bundle is ready.
 * Use this at the top of WithInternationalization so the tree never renders
 * with a missing bundle.
 */
export function useEnsureTranslationsLoaded(language: string): void {
  const bundleKey = getBundleKeyForLanguage(language);
  if (i18n.hasResourceBundle(bundleKey, 'translation')) return;

  let promise = getLoadPromiseForLanguage(i18n, bundleKey);
  if (!promise) promise = loadTranslationsForLanguage(i18n, bundleKey);
  throw promise;
}
